<template>
  <div class="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
    <div class="bg-card border border-slate-200 dark:border-zinc-700 rounded-xl p-8 flex flex-col items-center shadow-xl">
      <div class="relative">
        <!-- Outer ring -->
        <div class="animate-spin rounded-full h-12 w-12 border-4 border-slate-200 dark:border-zinc-700"></div>
        <!-- Inner animated ring -->
        <div class="animate-spin rounded-full h-12 w-12 border-4 border-transparent border-t-primary-600 absolute top-0 left-0"></div>
      </div>
      <p class="text-slate-700 dark:text-slate-300 font-medium mt-4">{{ text }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  text?: string
}

withDefaults(defineProps<Props>(), {
  text: 'Carregando...'
})</script>